import React, { memo } from 'react';
import Popup from '../helpers/Popup';
import FetchingError from '../helpers/FetchingError';
import Button from '../helpers/Button';
import Input from '../helpers/Input';

const AddHarvcoTagPopup = props => {
  const { isPopupFetching, isPopupFetchingError, onClose, onChange, onAddTag } = props;

  const header = 'Add HarvCo Tag';
  const footer = (
    <>
      <Button key="addTag" className="btn-primary" onClick={onAddTag}>
        Add Tag
      </Button>
      <Button key="close" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="addHarvCoTag" loading={isPopupFetching}>
      <Input
        className="input-md"
        id="tag"
        label="Apply the following HarvCo Tag to the selected companies:"
        name="tag"
        onChange={onChange}
        placeholder=""
        autoFocus
        showLabel
      />
      <FetchingError error={isPopupFetchingError} />
    </Popup>
  );
};

export default memo(AddHarvcoTagPopup);
